<template>
<div class="step-content" id="category">
    <div>
        <div class="entete">
            <span class="text-center d-block">{{ $t("component.category.select") }}</span>
        </div>
        <div class="d-flex justify-content-around flex-wrap">
            <div class="row-line" v-for="(tag, index) in tags" :key="tag.id">
                <div class="tag " v-on:click.prevent="selectedCategory(index)" v-if="tag.type == 'category'">
                    <span class="icon text-center bg-white shadow text-gray-100 mb-4 d-flex justify-content-center align-items-center">
                        <div>
                            <i :class="tag.icon" class="text-primary"></i>
                            <p class="label text-gray-500 text-center">{{tag.tag | multitranslate}}</p>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style>
.entete {
    margin-bottom: 1.5em;
}

#category .icon {
    width: 140px;
    height: 140px;
    border-radius: 15%;
    background-color: orange;
    border: 3px solid #ffffff;
    display: block;
}

#category [class*="icon-"]::before {
    padding-top: 0;
}

#category .icon i {
    font-size: 75px;
    line-height: normal;
    color: inherit;
}

.label {
    text-transform: uppercase;
    font-weight: 700;
}
</style>

<script>
import {
    EventManager
} from '@/components/Events/EventManager.js'
export default {
    name: 'Category',
    props: ['tags', 'item'],
    components: {
        EventManager
    },
    data: function () {
        return {}
    },
    created() {

    },
    methods: {
        selectedCategory: function (index) {
            var data = {
                'key': this.item.attributes[0].key,
                'content': this.tags[index].id
            };

            this.$emit('selected', data);
            EventManager.$emit('do-next');
        }
    }
}
</script>
